export default class {
	constructor(element) {
		this.element = element;
		this.handlers = {
			validationError: [],
		};
		this.initObserver();
	}

	initObserver() {
		const config = {
			childList: true,
			subTree: true,
		};

		const callback = (mutationsList) => {
			const $ = jQuery;
			mutationsList.forEach((mutation) => {
				if (mutation.type === 'childList' && mutation.addedNodes) {
					mutation.addedNodes.forEach((element) => {
						if ($(element).hasClass('et_bloom_error_message')) {
							this.emit('validationError');
						}
					});
				}
			});
		};
		this.observer = new MutationObserver(callback);
		this.observer.observe(this.element, config);
	}

	onValidationError(handler) {
		this.handlers.validationError.push(handler);
	}

	emit(event) {
		this.handlers[event].forEach((item) => {
			item.call(this, event);
		});
	}
}



// WEBPACK FOOTER //
// ./wp-content/plugins/core/assets/theme/js/src/accessibility/bloom/form_observer.js